import apiClient from '../axios';

const employeeService = {
    // Get all employees (admin only) with pagination
    getAllEmployees: async (page = 1, perPage = 20) => {
        try {
            const response = await apiClient.get(`/admin/employees?page=${page}&per_page=${perPage}`);
            return {
                success: true,
                data: response.data.data,
                meta: response.data.meta
            };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to fetch employees',
                error: error.response?.data?.error || error.message
            };
        }
    },

    // Get employee by ID
    getEmployeeById: async (employeeId) => {
        try {
            const response = await apiClient.get(`/admin/employees/${employeeId}`);
            return {
                success: true,
                data: response.data.data
            };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to fetch employee',
                error: error.response?.data?.error || error.message
            };
        }
    },

    // Create new employee
    createEmployee: async (employeeData) => {
        try {
            let config = {};
            if (employeeData instanceof FormData) {
                config.headers = { 'Content-Type': 'multipart/form-data' };
            }
            const response = await apiClient.post('/employee/register', employeeData, config);
            if (response.data && (response.data.success === true || response.data.status === 'success')) {
                return { success: true, data: response.data.data, message: response.data.message };
            } else {
                return { success: false, message: response.data.message || 'Failed to create employee', errors: response.data.errors };
            }
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to create employee',
                errors: error.response?.data?.errors || null,
                error: error.response?.data?.error || error.message
            };
        }
    },

    // Update employee
    updateEmployee: async (employeeId, employeeData) => {
        try {
            const response = await apiClient.put(`/admin/employees/${employeeId}`, employeeData);
            return {
                success: true,
                data: response.data.data,
                message: response.data.message
            };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to update employee',
                errors: error.response?.data?.errors || null,
                error: error.response?.data?.error || error.message
            };
        }
    },

    // Delete employee
    deleteEmployee: async (employeeId) => {
        try {
            const response = await apiClient.delete(`/admin/employees/${employeeId}`);
            return {
                success: true,
                message: response.data.message
            };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to delete employee',
                error: error.response?.data?.error || error.message
            };
        }
    },

    // Upload/update employee profile image (admin)
    updateProfileImage: async (employeeId, file) => {
        try {
            const formData = new FormData();
            formData.append('profile_image', file);
            const response = await apiClient.post(`/admin/employees/${employeeId}/profile-image`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return {
                success: true,
                image_url: response.data.image_url,
                message: response.data.message
            };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to update profile image',
                errors: error.response?.data?.errors || null,
                error: error.response?.data?.error || error.message
            };
        }
    }
};

export default employeeService; 